import { render } from "./PreviousYears.vue?vue&type=template&id=d17bdf32"
import script from "./PreviousYears.vue?vue&type=script&lang=js"
export * from "./PreviousYears.vue?vue&type=script&lang=js"

import exportComponent from "/Users/daniel/projects/laravel/gs1-ireland/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__